import TyumenOurHome from './component'

export default TyumenOurHome
